import { Component, OnInit, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { InvoiceService, Invoice, APIManager } from '@flashvpn-io/web-core';

@Component({
  selector: 'recharge-page',
  templateUrl: './recharge.component.html',
  styleUrls: ['./recharge.component.css']
})
export class RechargeComponent implements OnInit, OnDestroy {

  protected invoices: Invoice[] = [];
  private limitStart = 0;
  private limitNum = 10;
  protected total = 0;
  protected isLoading = false;
  protected isAllLoaded = false;

  constructor(
    private invoiceService: InvoiceService,
    private apiManager: APIManager,
    private elementRef: ElementRef
  ) { }

  ngOnInit(): void {
    this.loadInvoices();
    // 初始加载后检查是否需要加载更多
    setTimeout(() => this.checkAndLoadMore(), 100);
  }

  ngOnDestroy(): void {
    // 清理工作（如果需要）
  }

  private checkAndLoadMore(): void {
    const element = this.elementRef.nativeElement;
    const container = element.querySelector('.container');
    if (!container) return;

    const containerHeight = container.offsetHeight;
    const viewportHeight = window.innerHeight;

    // 如果内容高度小于视口高度，且还有更多数据可以加载，则触发加载
    if (containerHeight < viewportHeight && !this.isAllLoaded) {
      this.loadMoreInvoices();
    }
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(): void {
    // 检查是否滚动到底部
    if ((window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 100) {
      this.loadMoreInvoices();
    }
  }

  private loadInvoices(): void {
    if (this.isLoading) return;

    this.isLoading = true;
    this.invoiceService.refreshInvoiceInfo({
      "limitnum": this.limitNum,
      "limitstart": this.limitStart,
      "order": "descend",
      "orderby": "id",
      "status": "Paid"
    }).subscribe({
      next: (invoices) => {
        this.invoices = invoices.invoices ?? [];
        this.total = invoices.total ?? 0;
        this.isLoading = false;
        this.isAllLoaded = this.invoices.length >= this.total;
        // 检查是否需要加载更多
        this.checkAndLoadMore();
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  private loadMoreInvoices(): void {
    if (this.isLoading || this.isAllLoaded) return;

    this.isLoading = true;
    this.limitStart += this.limitNum;

    this.invoiceService.refreshInvoiceInfo({
      "limitnum": this.limitNum,
      "limitstart": this.limitStart,
      "order": "descend",
      "orderby": "id",
      "status": "Paid"
    }).subscribe({
      next: (invoices) => {
        const newInvoices = invoices.invoices ?? [];
        this.invoices = [...this.invoices, ...newInvoices];
        this.total = invoices.total ?? 0;
        this.isAllLoaded = this.invoices.length >= this.total;
        this.isLoading = false;
        // 检查是否需要继续加载更多
        this.checkAndLoadMore();
      },
      error: () => {
        this.limitStart -= this.limitNum; // 恢复之前的起始位置
        this.isLoading = false;
      }
    });
  }
}